module.exports = __webpack_public_path__ + "img/btn_top.7ef99ab5.svg";